import React from "react";
import { graphql } from "gatsby";
import Layout from "@qlik/qlik/src/components/Layout";
import BlogListing from "@qlik/qlik/src/components/CardContainer/Listing/Blog";
import DefaultPlaceholder from "@qlik/qlik/src/components/DefaultPlaceholder";
import HeroBannerImage from "@qlik/qlik/src/components/CardContainer/Hero_Banner_Image";

const TERM_TYPE_COMPONENT_MAPPING = {
    blogTerm: BlogListing,
};

/**
 * GraphQL query to retrieve all data for the flexible page.
 * Gatsby only allows one dynamic query per page.
 */
export const query = graphql`
    query {
        contentfulHeader(name: { eq: "Header" }) {
            ...Header
        }
        contentfulFooter(name: { eq: "Full footer" }) {
            ...Footer
        }
        contentfulThemeSettings {
            ...ThemeSettings
        }
    }
`;

/**
 * Page for Term
 * @param {Object} data - The data object returned from the GraphQL query
 * @returns {JSX.Element} - The rendered Blog component
 */
const Term = ({ data, pageContext: { slug, termType, selectedFilters } }) => {
    const TermListing = TERM_TYPE_COMPONENT_MAPPING[termType] ?? DefaultPlaceholder;

    // get Term title for hero banner
    const heroBannerData = { cardItem: { title: Object.values(selectedFilters)?.[0]?.[0] } };

    return (
        <Layout
            headerData={data.contentfulHeader}
            minimalHeaderData={data.contentfulThemeSettings?.minimalNavPages}
            footerData={data.contentfulFooter}
            pageSlug={slug}
            dynamicHeaderCta={data.contentfulThemeSettings?.dynamicHeaderCta}
            searchPopupData={data.contentfulThemeSettings?.searchPopupMicrocopyGroup}
        >
            <HeroBannerImage data={heroBannerData} />
            <TermListing className="pt-0 pb-10 xl:pb-20" data={{ selectedFilters }} />
        </Layout>
    );
};

export default Term;
